// 2_components/footer_bottom.js
// Footer bottom bar: toggles the language-switcher dropdown on touch/click and
// moves the online-payments block into the footer bottom row.

export function init() {
	if (!window.NAT?.utils?.addSmartTouchClickListener) {
		console.warn("[NAT] footer_bottom.js: window.NAT.utils.addSmartTouchClickListener missing — check load order");
		return;
	}

	footer = document.querySelector("#footer");

	footerLanguagesToggle();
	footerPaymentsMove();
}

let footer;

function footerLanguagesToggle() {
	if (!footer) {
		return;
	}
	const footerLanguagesWrapper = footer.querySelector(".footer-languages-wrapper");
	if (!footerLanguagesWrapper) {
		return;
	}
	const footerLanguagesToggleButton = footerLanguagesWrapper.querySelector(".footer-languages-current");
	if (!footerLanguagesToggleButton) {
		return;
	}
	window.NAT.utils.addSmartTouchClickListener(footerLanguagesToggleButton, function () {
		footerLanguagesWrapper.classList.toggle("active");
	});
}

function footerPaymentsMove() {
	if (!footer) {
		return;
	}
	const footerPaymentsWrapper = footer.querySelector(".footer-online-payments");
	if (!footerPaymentsWrapper) {
		return;
	}
	const footerBottom = footer.querySelector(".footer-bottom");
	if (!footerBottom) {
		return;
	}
	footerBottom.appendChild(footerPaymentsWrapper);
}
